var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notifications'),_c('div',[_c('top-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{staticStyle:{"padding-left":"20px","padding-right":"20px","margin-top":"-30px"}},[_c('router-view')],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }